import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core'
import { LoggerFactory } from '@elderbyte/ts-logger'
import {
  DataContextBuilder,
  IDataContext,
  LocalListDataSource,
  ElderTableComponent,
} from '@elderbyte/ngx-starter'
import { TracedMaterial } from '../traced-material'
import { TracedMaterialUpdate } from '../../traced-material-update'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { MatButton } from '@angular/material/button'
import { BatchTracingConfDetailComponent } from '../../conf/batch-tracing-conf-detail/batch-tracing-conf-detail.component'
import {
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
} from '@angular/material/table'
import { MatSort, MatSortHeader } from '@angular/material/sort'
import { FormsModule } from '@angular/forms'

@Component({
  selector: 'app-traced-material-single',
  templateUrl: './traced-material-single.component.html',
  styleUrls: ['./traced-material-single.component.scss'],
  imports: [
    FormsModule,
    ElderTableComponent,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatSortHeader,
    MatCellDef,
    MatCell,
    BatchTracingConfDetailComponent,
    MatButton,
    ElderTranslatePipe,
  ],
})
export class TracedMaterialSingleComponent implements OnInit, OnDestroy {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  private readonly localDataSrc: LocalListDataSource<TracedMaterial>
  public readonly data: IDataContext<TracedMaterial>

  @Output()
  public updates = new EventEmitter<TracedMaterialUpdate[]>()

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.localDataSrc = LocalListDataSource.empty('itemId')

    this.data = DataContextBuilder.start<TracedMaterial>()
      .reloadOnLocalChanges()
      .build(this.localDataSrc)
  }

  /***************************************************************************
   *                                                                         *
   * Life Cycle                                                              *
   *                                                                         *
   **************************************************************************/

  public ngOnInit(): void {
    this.data.start()
  }

  public ngOnDestroy(): void {
    if (this.data) {
      this.data.close()
    }
  }

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set tracedMaterials(materials: TracedMaterial[]) {
    this.localDataSrc.data = materials
    this.data.refresh()
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onConfirmTracingConfig(): void {
    const updates = this.data.snapshot.data.map((tm) => {
      const conf = tm.conf
      conf.specId = tm.spec.id
      return new TracedMaterialUpdate(tm.itemInfo.id, tm.workCenterId, tm.materialInfo.path, conf)
    })
    this.updates.emit(updates)
  }

  /***************************************************************************
   *                                                                         *
   * Private Methods                                                         *
   *                                                                         *
   **************************************************************************/
}
